import { render } from "./AccidentsInfo.vue?vue&type=template&id=7c8964c0"
import script from "./AccidentsInfo.vue?vue&type=script&lang=js"
export * from "./AccidentsInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__